'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import type { ToastConfigType } from '@/app/components/overlays/toast/types';
import { ALERT_MESSAGE } from '@/app/constants/alert-message';
import type { SocialMediaType } from '@/app/types/social-media';
import { isInAppBrowser, isMobileDevice } from '@/app/utils/browser';
import { copyToClipboard } from '@/app/utils/copyToClipboard';
import { createShareUrl, openShareUrl, wasShareCancelled } from '@/app/utils/share-social-media';
import logger from '@/lib/logger';
export const useSocialMediaShare = () => {
  const $ = _c(5);
  const [toast, setToast] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setToast(null);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const closeToast = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async () => {
      copyToClipboard(window.location.href, {
        onSuccess: () => {
          setToast({
            type: "success",
            isOpen: true,
            title: ALERT_MESSAGE.COPY_SUCCESS.title,
            message: ALERT_MESSAGE.COPY_SUCCESS.message
          });
        },
        onError: _temp
      });
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onCopyLink = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async type => {
      const currentUrl = window.location.href;
      if (type === "facebook" && isMobileDevice() && !isInAppBrowser()) {
        const canNativeShare = typeof navigator?.share === "function" && (typeof navigator.canShare !== "function" || navigator.canShare({
          url: currentUrl
        }));
        if (canNativeShare) {
          ;
          try {
            await navigator.share({
              title: document.title,
              url: currentUrl
            });
            return;
          } catch (t3) {
            const error_0 = t3;
            if (wasShareCancelled(error_0)) {
              return;
            }
            logger.error("Native share failed:", error_0);
          }
        }
        await onCopyLink();
        return;
      }
      openShareUrl(createShareUrl(type, currentUrl));
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onShare = t2;
  let t3;
  if ($[3] !== toast) {
    t3 = {
      toast,
      onShare,
      onCopyLink,
      closeToast
    };
    $[3] = toast;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(error) {
  logger.error("Failed to copy:", error);
}